const data = [
	{
		Research: `"IoT Attack Detection and Mitigation with Optimized Deep Learning 
		Techniques" (Journal of experimental & Theoretical Artificial Intelligence -Taylor & 
		Francis`,
	},
	{
		Research: `“Optimization-based hybrid deep learning technique for recognizing malicious 
		behavior in cloud computing” (Under publication in Multiagent and Grid Systems -
		IoS Press)
		`,
	},
	{
		Research: `"Anomaly Detection System in 5G Networks via Deep Learning Model"
		(Under publication in International Journal of Wireless Information NetworksSpringer)`,
	},
	{
		Research: `A Hybrid Meta-Heuristic Ensemble Based Classification Technique Speech Emotion 
		Recognition (Under publication Information Security Journal -Taylor & Francis)`,
	},
	{
		Research: `“Work from Home Analysis during epidemic using Machine Learning Algorithm”
		(Under publication in association with ICSIS 2022)`,
	},
	{
		Research: `“Machine Learning Algorithm for Work from Home Analysis During Epidemic”
		(Under publication with ACT 2022)`,
	},
	{
		Research: `“Automatic Text Document Classification by using Semantic Analysis and Lion 
		Optimization Algorithm” (Under publication in association with ICEI 2022)
		`,
	},
	{
		Research: `“Credit Card Fraud Detection by using Ensemble Method of Machine Learning”
		(Under publication in association with ICSIS 2022)
		`,
	},
	{
		Research: `“Detection of Parkinson Disease Using Handwriting Analysis” (Under publication in 
			association with ICSIS 2022)`,
	},
];

export default data;
